export const buildAddress = (
  address?: null | {
    __typename?: string | null;
    city?: string | null;
    county?: string | null;
    state?: string | null;
    street?: string | null;
    zipCode?: string | null;
  }
) => {
  if (!address) return '-';
  const { city, state, street, zipCode } = address;
  return `${street}, ${city}, ${state} ${zipCode}`;
};
